// extracted by mini-css-extract-plugin
module.exports = {"scheduleCreateEdit":"styles_scheduleCreateEdit__INYbM","createEditBody":"styles_createEditBody__V+HUe"};